import React from 'react'
import blobPath from './MyMapUtils/blobPath'
import GetfacilityTypeData from './MyMapUtils/GetfacilityTypeData';
import GetManagementStatus from './MyMapUtils/GetManagementStatus';
import GetApplicationInfo from './MyMapUtils/GetApplicationInfo';
const isLogin = window.SIMPL.isLogin;

export default function SearchResultItemTrafficRegulation(props) {

    return (         
        <div className="sr-itemcontainer"
            id={props.data?.id}
            onMouseEnter={() => props.onEnterItem(props.data) }    
            onMouseLeave={() => props.onLeaveItem(props.data) }
            onClick={()=>  isLogin ? window.open(window.location.origin + '/Detail/Details/' + props.data.id) : null }
        >
            <a className="sr-a" rel='noopener noreferrer' href="/#">{null}</a>
            <div className="sr-item">
                <div className="sr-flex">
                    <div className="sr-flex-icon">
                        <div className="sr-flex-icondiv">
                            <img decoding="async" className="sr-item-icon" src={GetfacilityTypeData(props.data.type,"icon")}
                                aria-hidden="true" alt="" />
                        </div>
                    </div>
                    <div className="sr-flex-info">
                            <div className="sr-flex-infodiv">
                                <div className="sr-item-title">
                                    <div className="sr-item-titlevalue">
                                        <span style={{ fontWeight: 'bold' }}>{props.data.title}</span>
                                    </div>
                                </div>
                                <div className="sr-item-property"><span>通行制限[{GetApplicationInfo("restrictedType",props.data?.restrictedType,"name")}]</span></div>
                                {/* 制限種類が「その他」の場合は表示 */}
                                {props.data?.restrictedType === "7" &&
                                    <div className="sr-item-property"><span>({props.data?.restrictedTypeOther})</span></div>
                                }
                                <div className="sr-item-property"><span>申請日　　：{props.data?.applicationDate}</span></div>
                                <div className="sr-item-property"><span>路線名　　：{props.data?.Roadtitle}</span></div>
                                <div className="sr-item-property"><span>地内　　　：{props.data?.restrictedPlace}</span></div>
                                <div className="sr-item-property"><span>時間帯　　：{GetApplicationInfo("restrictedTimeZone",props.data?.restrictedTimeZone,"name")}</span></div>
                                <div className="sr-item-property"><span>規制開始　：{props.data?.restrictedStartDateTime}</span></div>
                                <div className="sr-item-property"><span>規制終了　：{props.data?.restrictedEndDateTime}</span></div>
                                <div className="sr-item-property"><span>規制日数　：{props.data?.restrictedDays}</span></div>
                                <div className="sr-item-property"><span>迂回路　　：{props.data?.detourRoute ? "あり" : "なし"}</span></div>
                                <div className="sr-item-property"><span>ステータス：{GetManagementStatus("applicationStatus",props.data?.applicationStatus,"name")}</span></div>
                            </div>
                        </div>
                    <div className="sr-flex-img">
                        <div className="sr-flex-imgdiv">
                            <a href={blobPath(props.data?.PhotoURL)} target="_blank" rel="noopener noreferrer">
                                <img decoding="async" className="sr-item-img"
                                    src={blobPath(props.data.ThumbnailURL === null ? props.data.PhotoURL : props.data.ThumbnailURL)}
                                    aria-hidden="true" alt="" target="_blank"
                                    onMouseEnter={(e) => props.onEnterImg(e, (props.data?.ThumbnailURL === null ? props.data.PhotoURL : props.data.ThumbnailURL)) }    
                                    onMouseLeave={(e) => props.onLeaveImg(e, (props.data?.ThumbnailURL === null ? props.data.PhotoURL : props.data.ThumbnailURL)) }
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="sr-line"></div>
        </div>
    );
}